var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconConditionalStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1600_2653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.24 19.13H20.77V16.86C20.77 16.26 20.27 15.75 19.67 15.75H14.38L13.22 14.29V11.64H17.48C17.88 11.64 18.2 11.33 18.2 10.91V3.73C18.2 3.32 17.88 3 17.48 3H8.36C7.95 3 7.64 3.32 7.64 3.73V10.94C7.64 11.36 7.95 11.68 8.36 11.68H12.62V14.32L11.46 15.78H6.16C5.57 15.78 5.07 16.26 5.07 16.9V19.13H3.75C3.34 19.13 3 19.48 3 19.89V23.23C3 23.65 3.34 24 3.75 24H7.04C7.45 24 7.79 23.65 7.79 23.23V19.86C7.79 19.45 7.45 19.1 7.04 19.1H5.69V16.86C5.69 16.61 5.88 16.39 6.16 16.39H11.49L12.62 17.75V19.1H11.27C10.86 19.1 10.52 19.45 10.52 19.86V23.2C10.52 23.62 10.86 23.97 11.27 23.97H14.56C14.97 23.97 15.32 23.62 15.32 23.2V19.86C15.32 19.45 14.97 19.1 14.56 19.1H13.22V17.75L14.34 16.39H19.67C19.92 16.39 20.14 16.61 20.14 16.86V19.1H18.95C18.55 19.1 18.2 19.45 18.2 19.86V23.2C18.2 23.62 18.55 23.97 18.95 23.97H22.24C22.65 23.97 23 23.62 23 23.2V19.86C23 19.45 22.65 19.13 22.24 19.13ZM12.89 10.44C12.55 10.44 12.27 10.16 12.27 9.81V7.89H10.34C9.99 7.89 9.71 7.6 9.71 7.26C9.71 6.92 9.99 6.63 10.34 6.63H12.27V4.7C12.27 4.36 12.55 4.08 12.89 4.08C13.23 4.08 13.52 4.36 13.52 4.7V6.63H15.45C15.79 6.63 16.07 6.91 16.07 7.26C16.07 7.61 15.79 7.89 15.45 7.89H13.52V9.81C13.52 10.16 13.24 10.44 12.89 10.44Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1600_2653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConditionalStep);
export default __webpack_public_path__ + "static/media/iconConditionalStep.e5b85862.svg";
export { ForwardRef as ReactComponent };